<template>
    
</template>

<script>
    export default {
        name: "Dialog_ClassDetail"
    }
</script>

<style scoped>

</style>